/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './knob.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../../src/app/shared/knob/knob.component';
const styles_KnobComponent:any[] = [i0.styles];
export const RenderType_KnobComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_KnobComponent,data:{}});
export function View_KnobComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[i1.ɵqud(402653184,1,{inputEl:0}),(_l()(),i1.ɵeld(0,[[1,0],['inputEl',
      1]],(null as any),0,'input',[['type','text']],(null as any),(null as any),(null as any),
      (null as any),(null as any)))],(null as any),(null as any));
}
export function View_KnobComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'admin-knob',([] as any[]),
      (null as any),(null as any),(null as any),View_KnobComponent_0,RenderType_KnobComponent)),
      i1.ɵdid(4767744,(null as any),0,i2.KnobComponent,([] as any[]),(null as any),
          (null as any))],(null as any),(null as any));
}
export const KnobComponentNgFactory:i1.ComponentFactory<i2.KnobComponent> = i1.ɵccf('admin-knob',
    i2.KnobComponent,View_KnobComponent_Host_0,{min:'min',max:'max',step:'step',angleOffset:'angleOffset',
        angleArc:'angleArc',stopper:'stopper',rotation:'rotation',value:'value',capRounded:'capRounded',
        displayInput:'displayInput',displayPrevious:'displayPrevious',fgColor:'fgColor',
        inputColor:'inputColor',bgColor:'bgColor',cursor:'cursor',width:'width',height:'height',
        thickness:'thickness'},{valueChange:'valueChange'},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUva3NtYWkvd2ViZGV2L2FkbWluLXRlbXBsYXRlL3NyYy9hcHAvc2hhcmVkL2tub2Iva25vYi5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vaG9tZS9rc21haS93ZWJkZXYvYWRtaW4tdGVtcGxhdGUvc3JjL2FwcC9zaGFyZWQva25vYi9rbm9iLmNvbXBvbmVudC50cyIsIm5nOi8vL2hvbWUva3NtYWkvd2ViZGV2L2FkbWluLXRlbXBsYXRlL3NyYy9hcHAvc2hhcmVkL2tub2Iva25vYi5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUva3NtYWkvd2ViZGV2L2FkbWluLXRlbXBsYXRlL3NyYy9hcHAvc2hhcmVkL2tub2Iva25vYi5jb21wb25lbnQudHMuS25vYkNvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxpbnB1dCB0eXBlPVwidGV4dFwiICNpbnB1dEVsPiIsIjxhZG1pbi1rbm9iPjwvYWRtaW4ta25vYj4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7cURDQUE7TUFBQTtNQUFBOzs7b0JDQUE7TUFBQTthQUFBO1VBQUE7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// ./$$_gendir/src/app/shared/knob/knob.component.ngfactory.ts